import api from '../services/api';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Opens a Zoho quote's M4_Quote PDF attachment for VIEWING in a new browser
 * tab (rather than forcing a download), so the user can preview it straight
 * from the CRM record. The tab is opened synchronously (before the async
 * fetch) so browser popup-blockers don't kill it once the blob is ready.
 */
export async function viewQuotePdf(quoteId, subject = '') {
  const url = `${API}/zoho/quotes/${quoteId}/pdf-download`;
  const newTab = window.open('', '_blank');
  const toastId = toast.loading('Opening PDF…');
  try {
    const res = await api.get(url, { responseType: 'blob' });
    const blob = new Blob([res.data], {
      type: res.headers['content-type'] || 'application/pdf',
    });
    const blobUrl = URL.createObjectURL(blob);
    if (newTab) {
      newTab.location.href = blobUrl;
      toast.success('PDF opened', { id: toastId });
    } else {
      // Popup blocked — fall back to a direct download so the user still gets the file
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = subject ? `${subject}.pdf` : 'quote.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      toast.success('PDF downloaded (popup was blocked)', { id: toastId });
    }
  } catch (e) {
    if (newTab) newTab.close();
    const detail = e?.response?.data?.detail || e?.message || 'Failed to open PDF';
    toast.error(detail, { id: toastId });
  }
}
